import React from "react";
import "./NeedsToActivate.css";
export default function NeedsToActivate() {
  return (
    <div className="needs-to-activate-container">
      <div className="needs-to-activate-children">
        <p>
          This account is created but not <br /> activated yet!
        </p>
      </div>
    </div>
  );
}
